import validSvc from '../../validSvc';
import { sortFnByColType } from './sortFnByColType';
import { TblCol, TblSort } from '../table.types';

export function tableDataSortItems<T>(items: T[], cols: TblCol[], sort: TblSort): T[] {
    /** Create a copy from `items` to prevent readonly mutation error. */
    const nextItems = Array.from(items);
    // null array (this happens from golang)
    if (!Array.isArray(items)) {
        return [];
    }

    // columns or sort isn't ready, avoid blow up
    if (!Array.isArray(cols) || cols.length < 1 || !!!sort || !validSvc.isText(sort.col)) {
        return items;
    }
    const foundColumn = cols.find(c => {
        return c.key == sort.col;
    });

    // sort column not set or not enough items
    if (!foundColumn || !foundColumn.type || items.length < 2) {
        return items;
    }

    // get sort fn (standard convention: ASC = ascending, DSC = descending)
    const sortDir = sort.dir === 'DSC' ? 'DSC' : 'ASC';
    const sortFn = sortFnByColType(foundColumn.type, sort.col, sortDir);

    return nextItems.sort(sortFn);
}
